import { useEffect, useState } from "react";
import Dropdown from "../../Hooks/Dropdown";
import DeleteModal from "../../Hooks/DeleteModal";
import Table from "react-bootstrap/Table";
import EditIcon from "../../assets/images/edit (5).svg";
import DeleteIcon from "../../assets/images/trash (1).svg";
import ModalLogo from "../../assets/images/briefcase (1).svg";
import {
  getCityListService,
  updateCityService,
  deleteCityService,
  createCityService,
} from "../../services/userService";

import { Modal } from "react-bootstrap";
import CrossIcon from "../../assets/images/cross_icon.svg";
import { PageLoader } from "../svg";
import ReactPaginate from "react-paginate";
import SearchIcon from "../../assets/images/search (5).svg";
import ArrowDown from "../../assets/images/arrow-down.svg";
import ArrowUp from "../../assets/images/arrow-up.svg";

const City = () => {
  const [loader, setLoader] = useState(true);

  const [createModal, setCreateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);

  const [city, setCity] = useState("");
  const [cityErr, setCityErr] = useState("");

  const [cityCode, setCityCode] = useState("");
  const [cityCodeErr, setCityCodeErr] = useState("");


  const [id, setId] = useState("");
  const [cityList, setCityList] = useState([]);

  const [cityName, setCityName] = useState("");
  const [cityNameErr, setCityNameErr] = useState("");

  const [updateCityNameErr, setUpdateCityNameErr] = useState("");
  const [updateCityCodeErr, setUpdateCityCodeErr] = useState("");

  const [updateCity, setUpdateCity] = useState("");

  const [search, setSearch] = useState("");
  const limit = 10;
  const [totalCount, setTotalCount] = useState(1);
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);

  const [sortKey, setSortKey] = useState("");
  const [type, setType] = useState("");

  const [recordCount, setRecordCount] = useState(0);

  localStorage.removeItem('page');


  const arrowClick = (sortType, sortOrder) => {
    setSortKey(sortType);
    setType(sortOrder);
    getCityList({
      limit: limit,
      page: page,
      ...((search!=='' && search!==null) &&  {search: search}),
      ...((type!=='' && type!==null) &&  {type: type}),
      ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
    })
  };



  const handlePageClick = (event) => {
    let pageNumber = event.selected + 1;
    setPage(event.selected + 1);
    getCityList({
      limit: limit,
      page: pageNumber,
      ...((search!=='' && search!==null) &&  {search: search}),
      ...((type!=='' && type!==null) &&  {type: type}),
      ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
    })
  };

  const handleAddCity = () => {
    setCreateModal(true);
  };


  const getCityList = (query) => {

    getCityListService(query).then((res) => {
      setCityList(res.data.responseData.result);
      setLoader(false);
      let count = res.data.responseData.count;
      setRecordCount(count);
      let numberOfPages = Math.ceil(count / 10);
      setTotalCount(numberOfPages);
    });
  };

  const updateCityFunctionData = (event, key) => {
    setUpdateCity((prev) => ({ ...prev, [key]: event }));
  };



  useEffect(() => {
    let _intervalTime;
    if (search !== "" && search !== null) {
      _intervalTime = setTimeout(() => {
        getCityList({
          limit: limit,
          page: page,
          ...((search!=='' && search!==null) &&  {search: search}),
          ...((type!=='' && type!==null) &&  {type: type}),
          ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
        });
      }, 1500);
    } else {
      getCityList({
        limit: limit,
        page: page,
        ...((search!=='' && search!==null) &&  {search: search}),
        ...((type!=='' && type!==null) &&  {type: type}),
        ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
      });
    }
    return () => {
      clearTimeout(_intervalTime);
    };
    // eslint-disable-next-line
  }, [type,sortKey,search]);

  const deleteCity = (_id) => {
    setDeleteModal(true);
    setId(_id);
  };

  const updateCityClick = (item) => {
    setUpdateModal(true);
    setUpdateCity(item);
  };

  const handleClose = () => {

    setDeleteModal(false);
    setCreateModal(false);

    setCityNameErr("");
    setCityErr("");
    setCity("");
    setCityName("");
    setCityCode("")
  };

  const handleUpdateCloseFunction = (e) => {
    setUpdateModal(false);
  };

  // To prevent entering white spaces in add

  const handleKeyDown = (e) => {
    if (e.key === " " && city.length === 0) {
      e.preventDefault();
    }
  };

  // Add Validation
  const validation = () => {
    let validate = true;
    if (cityCode == "") {
      setCityCodeErr("City Code is required");
      validate = false;
    } 
    if (city == "") {
      setCityErr("City is required");
      validate = false;
    }

    return validate;
  };

  // To prevent entering white spaces in update

  const handleUpdateKeyDown = (e) => {
    if (e.key === " " && updateCity.city_name.length === 0) {
      e.preventDefault();
    }
  };

  // Update validation

  const updateValidation = () => {
    let validate = true;

    if (updateCity.city_name === "") {
      setUpdateCityNameErr("City name is required");
      validate = false;
    }
    return validate;
  };

  //create City
  const handleAddClick = () => {
    if (validation()) {
      createCityService({ city_name: city, city_code: cityCode }).then(
        (res) => {
          setCreateModal(false);
          handleClose();
          getCityList({
            limit: limit,
            page: page,
            ...((search!=='' && search!==null) &&  {search: search}),
            ...((type!=='' && type!==null) &&  {type: type}),
            ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
          });
        }
      );
    }
  };

  //delete City

  const handleDeleteClick = () => {
    deleteCityService({ _id: id }).then((res) => {
      setDeleteModal(false);
      getCityList({
        limit: limit,
        page: page,
        ...((search!=='' && search!==null) &&  {search: search}),
        ...((type!=='' && type!==null) &&  {type: type}),
        ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
      });
    });
  };

  //update City

  const handleUpdateClick = () => {
    if (updateValidation()) {
      if (updateCity.city_name && updateCity.city_code) {
        updateCityService({
          city_name: updateCity.city_name,
          city_code: updateCity.city_code,
          _id: updateCity._id,
        }).then((res) => {
          setUpdateModal(false);
          getCityList({
            limit: limit,
            page: page,
            ...((search!=='' && search!==null) &&  {search: search}),
            ...((type!=='' && type!==null) &&  {type: type}),
            ...((sortKey!=='' && sortKey!==null) &&  {sort_key: sortKey}),
          });
        });
      }
    }
  };

 
  const handleCityCode = (e) => {
    const reg = new RegExp("^[0-9]+$");

    if (
      (reg.test(e.target.value) || cityCode.length == 1) &&
      e.target.value.length <= 14
    ) {
      setCityCode(e.target.value) 
    }
    setCityCodeErr("")
  };

  return (
    <>
      <div className="page_wrapper">
          <div className="container-box">

            <div className=" distributor-head">
              <div className="row mt-4">
                <div className="col-md-4">
                  <h4 className="semibold-font">City</h4>
                </div>

                <div className="col-md-5 ">
                  <img src={SearchIcon} className="search-icon" />

                  <input
                    type="text"
                    placeholder="Search by name"
                    name="search"
                    className=" search box-shadow light-italic-font"
                    value={search}
                    onChange={(e) => (setSearch(e.target.value))}
                  ></input>
                </div>

                <div className="col-md-2  ">
                  <button
                    className="add-btn text-white box-shadow  medium-font grey-font"
                    onClick={handleAddCity}
                  >
                    Add City
                  </button>
                </div>
              </div>
            </div>
            <Table className="table box-shadow">
              <thead>
                <tr>
                  <th>S. No</th>
                  <th>
                    City Name
                    <span className="arrows pointer">
                      <img
                        src={ArrowUp}
                        alt="arrow-up"
                        height={10}
                        width={10}
                        onClick={() => arrowClick("city_name", 1)}
                      />
                      <img
                        src={ArrowDown}
                        alt="arrow-down "
                        height={10}
                        width={10}
                        onClick={() => arrowClick("city_name", -1)}
                      />
                    </span>
                  </th>
                  <th>
                    City Code
                    <span className="arrows pointer">
                      <img
                        src={ArrowUp}
                        alt="arrow-up"
                        height={10}
                        width={10}
                        onClick={() => arrowClick("city_code", 1)}
                      />
                      <img
                        src={ArrowDown}
                        alt="arrow-down "
                        height={10}
                        width={10}
                        onClick={() => arrowClick("city_code", -1)}
                      />
                    </span>
                  </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {cityList &&
                  cityList.map((item, index) => (
                    <tr>
                      <td>{limit * pageCount + index + 1}</td>
                      <td>{item.city_name}</td>
                      <td>{item.city_code}</td>

                      <td>
                        <img
                          src={EditIcon}
                          alt="edit"
                          onClick={() => updateCityClick(item)}
                        />
                        <img
                          src={DeleteIcon}
                          alt="delete"
                          className="dlt-icon"
                          onClick={() => deleteCity(item._id)}
                        />
                      </td>
                    </tr>
                  ))}
                {cityList?.length ? (
                  ""
                ) : (
                  <tr className="text-center">
                    <td></td>

                    <td className="text-end no_data">
                      <p>No Data Found</p>
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
            {loader ? (
              <div className="loader_data">
                <PageLoader />
              </div>
            ) : (
              ""
            )}
            {recordCount > limit ? (
              <ReactPaginate
                previousLabel={"previous"}
                nextLabel={"next"}
                breakLabel={"..."}
                pageCount={totalCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={3}
                onPageChange={handlePageClick}
                containerClassName={"pagination "}
                pageClassName={"page-item"}
                pageLinkClassName={"page-link"}
                previousClassName={"page-item"}
                previousLinkClassName={"page-link"}
                nextClassName={"page-item"}
                nextLinkClassName={"page-link"}
                breakClassName={"page-item"}
                breakLinkClassName={"page-link"}
                activeClassName={"active"}
                hrefBuilder={(page, pageCount, selected) =>
                  setPageCount(selected)
                }
              />
            ) : null}
          </div>
      </div>

      {/* Delete City Modal */}
      <DeleteModal
        deleteModal={deleteModal}
        title="City"
        Icon={CrossIcon}
        handleClose={handleClose}
        handleDeleteClick={handleDeleteClick}
      ></DeleteModal>

      {/* Create City Modal */}

      <Modal show={createModal} onHide={handleClose} centered>
        <Modal.Header closeButton className="display"></Modal.Header>

        <Modal.Body>
          <div className="modal-box">
            <div className="text-center">
              <img src={ModalLogo} />
              <h5 className="semibold-font mt-3">
                Add City
              </h5>
            </div>
            

            <input
              type="text"
              placeholder="CITY NAME"
              maxLength={30}
              className="form-control mt-4 smaller-font"
              value={city}
              onKeyDown={handleKeyDown}
              onChange={(e) => (setCity(e.target.value), setCityErr(""))}
              />
           
            <div className="error-message">{cityErr ? cityErr : ""}</div>

            <input
              type="text"
              placeholder="CITY CODE"
              maxLength={30}
              className="form-control mt-4 smaller-font"
              value={cityCode}
              onKeyDown={handleKeyDown}
              onChange={handleCityCode}
            />
            <div className="error-message">{cityCodeErr ? cityCodeErr : ""}</div>

            <button
              className="add-modal-btn mt-3  btn-padding text-white"
              onClick={handleAddClick}
            >
              ADD
            </button>
          </div>
        </Modal.Body>
      </Modal>

      {/*Update City modal*/}

      <Modal show={updateModal} onHide={handleUpdateCloseFunction} centered>
        <Modal.Header closeButton className="display"></Modal.Header>

        <Modal.Body>
          <div className="modal-box">
            <div className="text-center">
              <img src={ModalLogo} />
              <h5 className="semibold-font mt-3">
                Update City
              </h5>
            </div>
            <input
              type="text"
              placeholder="City NAME"
              className="form-control mt-4 smaller-font"
              value={updateCity.city_name}
              onKeyDown={handleUpdateKeyDown}
              onChange={(e) => (
                updateCityFunctionData(e.target.value, "city_name"),
                setUpdateCityNameErr("")
              )}
            />
            <div className="error-message">
              {updateCityNameErr ? updateCityNameErr : ""}
            </div>

            {/* City Code */}

            <input
              type="text"
              placeholder="City Code"
              className="form-control mt-4 smaller-font"
              value={updateCity.city_code}
              onKeyDown={handleUpdateKeyDown}
              onChange={(e) => (
                updateCityFunctionData(e.target.value, "city_code"),
                setUpdateCityNameErr("")
              )}
            />
            <div className="error-message">
              {updateCityCodeErr ? updateCityCodeErr : ""}
            </div>



           

            <button
              className="add-modal-btn mt-3  update-btn-padding text-white"
              onClick={handleUpdateClick}
            >
              UPDATE
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default City;
